import {
  IntersectionObserverProps,
  InView as OriginalInView,
  PlainChildrenProps,
} from 'react-intersection-observer';

export const InView = OriginalInView as unknown as React.ElementType<
  Omit<
    (IntersectionObserverProps | PlainChildrenProps) & {
      render(): React.ReactNode | {} | null | undefined;
    },
    'render'
  >
>;
